const productData = [
  {
    id: 1,
    name: "Classic Fleece Hoodie Bordeaux",
    category: "Hoodie",
    price: "75.00",
    originalPrice: null,
    reviews: "88",
    rating: "4.8",
    image: "/img/101.jpeg",
    images: ["/img/101.jpeg", "/img/101a.jpeg", "/img/101b.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Bordeaux"],
    material: "Heavy Fleece",
    description: [
      "A premium collaboration between MadHappy and Liiskerlane, featuring a rich burgundy colorway that adds sophistication to your pet's wardrobe.",
      "This classic fleece hoodie is crafted from heavyweight 330gsm fleece for ultimate warmth and comfort during cold weather walks.",
      "The relaxed fit allows for easy layering and unrestricted movement, while the premium hardware ensures durability through countless adventures.",
    ],
    Features: [
      "MadHappy x Liiskerlane official collaboration piece",
      "Heavyweight 330gsm fleece for superior warmth",
      "Functional hood with drawstring adjusters",
      "Premium YKK zipper closure",
      "Embroidered logo detail on chest",
      "Ribbed cuffs and hem for secure fit",
      "Machine washable for easy care",
    ],
    soldOut: true,
  },
  {
    id: 2,
    name: "Classic Fleece Hoodie Frost",
    category: "Hoodie",
    price: "75.00",
    originalPrice: null,
    reviews: "72",
    rating: "4.9",
    image: "/img/102.jpeg",
    images: ["/img/102.jpeg", "/img/102a.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Blue"],
    material: "Heavy Fleece",
    description: [
      "A fresh and icy blue interpretation of the classic fleece hoodie, brought to you through the MadHappy x Liiskerlane collaboration.",
      "This premium hoodie features the same heavyweight construction as the Bordeaux version, ensuring your pet stays warm in style.",
      "The Frost colorway offers a cool, modern aesthetic that stands out during winter strolls and cozy indoor moments.",
    ],
    Features: [
      "MadHappy x Liiskerlane official collaboration piece",
      "Heavyweight 330gsm fleece construction",
      "Attached hood with adjustable drawstrings",
      "Durable YKK zipper for easy on/off",
      "Soft interior fleece lining for extra comfort",
      "Stretch ribbed cuffs and hem",
      "Available in extended size range for all breeds",
    ],
    soldOut: true,
  },
  {
    id: 3,
    name: "Ladybug Raincoat",
    category: "Raincoat",
    price: "58.00",
    originalPrice: null,
    reviews: "64",
    rating: "4.9",
    image: "/img/103.jpeg",
    images: ["/img/103.jpeg", "/img/103a.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Red/Black"],
    material: "Waterproof Polyester",
    description: [
      "Keep your furry friend dry and adorable with this charming ladybug-inspired raincoat featuring iconic black spots on a vibrant red background.",
      "Crafted from fully waterproof polyester with sealed seams to ensure no water penetrates, keeping your pet comfortable even in heavy rain.",
      "The adjustable belly strap and leash hole design make this raincoat both functional and easy to put on, perfect for rainy day adventures.",
    ],
    Features: [
      "100% waterproof construction with sealed seams",
      "Adorable ladybug print with black polka dots",
      "Hooded design for extra protection",
      "Adjustable belly strap for secure fit",
      "Reflective trim for visibility in low light",
      "Leash hole for easy collar attachment",
      "Available in multiple sizes from XXS to XL",
    ],
    soldOut: false,
  },
  {
    id: 4,
    name: "Snoopy Gift Stripe Onesie",
    category: "Onesie",
    price: "47.00",
    originalPrice: null,
    reviews: "156",
    rating: "4.8",
    image: "/img/104.jpeg",
    images: ["/img/104.jpeg", "/img/104a.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Green Stripe"],
    material: "Soft Jersey Cotton",
    description: [
      "A delightful PEANUTS collaboration featuring Snoopy in a festive gift-giving theme, perfect for the holiday season or any special occasion.",
      "This onesie combines the charm of Charles M. Schulz's beloved characters with Liiskerlane's signature quality and comfort.",
      "The full-body coverage design is ideal for keeping warm, preventing scratching at wounds, or simply making a statement at the dog park.",
    ],
    Features: [
      "Officially licensed PEANUTS merchandise",
      "Festive gift-themed stripe pattern featuring Snoopy",
      "Snap button closure for easy dressing",
      "Full body coverage for warmth and comfort",
      "Stretchy jersey fabric for unrestricted movement",
      "Machine washable cotton blend",
      "Extended size range including XXS to XXL",
    ],
    soldOut: true,
  },
  {
    id: 5,
    name: "Snoopy Gift Stripe Shirt",
    category: "Shirt",
    price: "48.00",
    originalPrice: null,
    reviews: "145",
    rating: "4.7",
    image: "/img/105.jpeg",
    images: ["/img/105.jpeg", "/img/105a.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Green Stripe"],
    material: "Soft Jersey Cotton",
    description: [
      "The matching shirt version of our popular Snoopy Gift Onesie, offering the same festive charm in a more relaxed fit for upper body coverage.",
      "Part of the PEANUTS collection, this shirt showcases Snoopy in gift-giving poses surrounded by festive stripes and holiday spirit.",
      "Perfect for pets who prefer less coverage while still enjoying the warmth and style of the Snoopy Gift collection.",
    ],
    Features: [
      "Official PEANUTS licensed product",
      "Snoopy gift-themed stripe design",
      "Comfortable crew neckline",
      "Short sleeve design for warm weather",
      "Soft breathable cotton blend",
      "Easy pull-on style",
      "Multiple sizes from XXS to XXL",
    ],
    soldOut: true,
  },
  {
    id: 6,
    name: "Snoopy & Woodstock Stripe Shirt",
    category: "Shirt",
    price: "48.00",
    originalPrice: null,
    reviews: "134",
    rating: "4.8",
    image: "/img/106.jpeg",
    images: ["/img/106.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Stripe"],
    material: "Soft Jersey Cotton",
    description: [
      "Featuring both Snoopy and his best friend Woodstock, this charming stripe shirt captures the essence of friendship and adventure.",
      "The classic PEANUTS characters are rendered in a timeless stripe pattern that appeals to dog lovers of all ages.",
      "Lightweight and comfortable, this shirt is perfect for everyday wear or special PEANUTS-themed events.",
    ],
    Features: [
      "Officially licensed PEANUTS collection",
      "Features both Snoopy and Woodstock characters",
      "Classic stripe pattern design",
      "Lightweight cotton jersey construction",
      "Comfortable relaxed fit",
      "Crew neck styling",
      "Available in comprehensive size range",
    ],
    soldOut: true,
  },
  {
    id: 7,
    name: "Holiday Puffer Jacket",
    category: "Parka",
    price: "88.00",
    originalPrice: null,
    reviews: "42",
    rating: "4.6",
    image: "/img/107.jpeg",
    images: ["/img/107.jpeg", "/img/107a.png"],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Blue/Red"],
    material: "Down Alternative Fill",
    description: [
      "A festive PEANUTS collaboration puffer jacket featuring Snoopy peeking through holiday-inspired patterns of blue and red.",
      "Filled with premium down alternative insulation, this puffer provides exceptional warmth without the bulk of traditional fills.",
      "The quilted design not only adds visual interest but also ensures even distribution of fill throughout the jacket.",
    ],
    Features: [
      "Official PEANUTS licensed holiday collection",
      "Premium down alternative insulation for warmth",
      "Quilted construction prevents fill shifting",
      "Lightweight yet extremely warm",
      "Full zipper closure for easy on/off",
      "Hooded design for head protection",
      "Holiday-themed Snoopy pattern",
    ],
    soldOut: false,
  },
  {
    id: 8,
    name: "Hot Sauce Fleece Onesie",
    category: "Onesie",
    price: "35.00",
    originalPrice: "50.00",
    discount: "30%",
    reviews: "92",
    rating: "4.7",
    image: "/img/108.jpeg",
    images: ["/img/108.jpeg", "/img/108a.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Red"],
    material: "Polar Fleece",
    description: [
      "Bring the heat to your pet's wardrobe with this sizzling hot sauce themed onesie featuring bold graphics and spicy personality.",
      "Made from ultra-soft polar fleece that provides excellent warmth while remaining lightweight and breathable.",
      "The fun sauce bottle design adds humor and character, making this a standout piece for pets with attitude.",
    ],
    Features: [
      "Vibrant hot sauce bottle graphic print",
      "Ultra-soft polar fleece material",
      "Full body coverage design",
      "Snap button closure for easy dressing",
      "Stretchy fabric allows free movement",
      "Anti-pill fleece maintains appearance",
      "Multiple color options available",
    ],
    soldOut: false,
  },
  {
    id: 9,
    name: "Hot Sauce Fleece Shirt",
    category: "Fleece Shirt",
    price: "33.00",
    originalPrice: "48.00",
    discount: "31%",
    reviews: "45",
    rating: "4.8",
    image: "/img/109.jpeg",
    images: ["/img/109.jpeg", "/img/109a.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Red"],
    material: "Polar Fleece",
    description: [
      "The shirt version of our popular Hot Sauce collection, featuring the same fiery design in a more versatile upper-body style.",
      "Perfect for pets who prefer less coverage while staying warm and showcasing their spicy personality.",
      "The button-front design allows for easy on/off while adding a touch of style to the classic fleece look.",
    ],
    Features: [
      "Matching hot sauce graphic design",
      "Button front closure for easy dressing",
      "Polar fleece for warmth and softness",
      "Spread collar for classic style",
      "Chest pocket detail",
      "Machine washable fabric",
      "Sale price - limited time offer",
    ],
    soldOut: true,
  },
  {
    id: 10,
    name: "LB Gold Pendant",
    category: "Pendant",
    price: "28.00",
    originalPrice: null,
    reviews: "15",
    rating: "4.5",
    image: "/img/1010.jpeg",
    images: ["/img/1010.jpeg"],
    size: ["OS"],
    colors: ["Gold"],
    material: "Gold Plated",
    description: [
      "Add a touch of elegance to your pet's look with this beautifully crafted gold pendant featuring the iconic Liiskerlane logo.",
      "Made from high-quality gold plating that provides a luxurious appearance without the premium price tag.",
      "The delicate chain is adjustable and comfortable, making this pendant suitable for daily wear.",
    ],
    Features: [
      "Genuine gold plating finish",
      "Liiskerlane signature logo pendant",
      "Adjustable chain length",
      "Lightweight and comfortable",
      "Secure lobster clasp closure",
      "Hypoallergenic materials",
      "Perfect for special occasions or everyday elegance",
    ],
    soldOut: true,
  },
  {
    id: 11,
    name: "LB Silver Pendant",
    category: "Pendant",
    price: "28.00",
    originalPrice: null,
    reviews: "12",
    rating: "4.6",
    image: "/img/1011.jpeg",
    images: ["/img/1011.jpeg"],
    size: ["OS"],
    colors: ["Silver"],
    material: "Silver Plated",
    description: [
      "A sophisticated silver alternative to our gold pendant, offering the same elegant Liiskerlane branding in a cool-toned finish.",
      "The sterling silver plating provides durability and a brilliant shine that complements any fur color.",
      "This pendant makes a perfect gift for pet owners who appreciate minimalist yet stylish accessories.",
    ],
    Features: [
      "Premium silver plating",
      "Liiskerlane emblem design",
      "Adjustable chain for perfect fit",
      "Tarnish-resistant coating",
      "Secure snap closure",
      "Lightweight elegant design",
      "Ideal for matching with owner jewelry",
    ],
    soldOut: true,
  },
  {
    id: 12,
    name: "Ended Up in New York Canvas Tote",
    category: "Carrier",
    price: "198.00",
    originalPrice: null,
    reviews: "8",
    rating: "5.0",
    image: "/img/1012.jpeg",
    images: [
      "/img/1012.jpeg",
      "/img/1012a.jpeg",
      "/img/1012b.jpeg",
      "/img/1012c.jpeg",
    ],
    size: ["OS"],
    colors: ["Leopard"],
    material: "Canvas",
    description: [
      "A stylish canvas tote bag featuring the bold leopard print that has become synonymous with the Liiskerlane brand.",
      "Designed for pet owners on the move, this tote provides ample space for essentials while keeping your furry friend comfortable.",
      "The durable canvas construction ensures longevity, while the eye-catching print makes a fashion statement wherever you go.",
    ],
    Features: [
      "Premium canvas material",
      "Signature leopard print design",
      "Spacious main compartment",
      "Interior pocket for small items",
      "Comfortable shoulder straps",
      "Ventilation windows for pet comfort",
      "Secure pet containment inside",
    ],
    soldOut: false,
  },
  {
    id: 13,
    name: "Audrey - Flower Power Leash",
    category: "Leash",
    price: "85.00",
    originalPrice: null,
    reviews: "28",
    rating: "4.8",
    image: "/img/1013.jpeg",
    images: [
      "/img/1013.jpeg",
      "/img/1013a.jpeg",
      "/img/1013b.jpeg",
      "/img/1013c.jpeg",
    ],
    size: ["OS"],
    colors: ["Floral"],
    material: "Printed Webbing",
    description: [
      "Embrace the flower power aesthetic with this beautifully designed leash featuring vibrant floral patterns.",
      "The premium printed webbing maintains its color and pattern through countless walks and washes.",
      "A matching collar is available to complete the coordinated look for your stylish pet.",
    ],
    Features: [
      "Vibrant flower power print design",
      "Durable printed webbing construction",
      "Strong metal hardware clips",
      "Comfortable padded handle",
      "Multiple leash length options",
      "Matching collar available",
      "Machine washable materials",
    ],
    soldOut: false,
  },
  {
    id: 14,
    name: "Audrey - Flower Power Collar",
    category: "Collar",
    price: "65.00",
    originalPrice: null,
    reviews: "35",
    rating: "4.9",
    image: "/img/1014.jpeg",
    images: [
      "/img/1014.jpeg",
      "/img/1014a.jpeg",
      "/img/1014b.jpeg",
      "/img/1014c.jpeg",
    ],
    size: ["XS", "S", "M", "L"],
    colors: ["Floral"],
    material: "Printed Webbing",
    description: [
      "The perfect companion piece to the Audrey Flower Power Leash, this collar features the same stunning floral design.",
      "Crafted from the same high-quality printed webbing, ensuring color vibrancy and durability throughout the collar's life.",
      "The adjustable design ensures a comfortable fit for pets of various sizes.",
    ],
    Features: [
      "Coordinating flower power pattern",
      "Adjustable buckle closure",
      "Durable plastic buckle",
      "Strong D-ring for leash attachment",
      "ID tag ring included",
      "Machine washable fabric",
      "Available in multiple sizes",
    ],
    soldOut: false,
  },
  {
    id: 15,
    name: "Cloud Nine Fleece Shirt",
    category: "Fleece Shirt",
    price: "33.00",
    originalPrice: "48.00",
    discount: "31%",
    reviews: "78",
    rating: "4.8",
    image: "/img/1015.jpeg",
    images: ["/img/1015.jpeg", "/img/1015a.jpeg", "/img/1015b.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Blue"],
    material: "Polar Fleece",
    description: [
      "Float on cloud nine with this dreamy blue fleece shirt featuring soft, cloud-like comfort for your pet.",
      "The gentle blue hue creates a calming aesthetic while the plush fleece provides exceptional warmth.",
      "Part of our popular Cloud Nine collection, this shirt has become a customer favorite for its comfort and style.",
    ],
    Features: [
      "Soothing blue colorway",
      "Ultra-soft polar fleece construction",
      "Button front closure",
      "Spread collar detail",
      "Lightweight warmth",
      "Easy care machine wash",
      "Sale pricing available",
    ],
    soldOut: false,
  },
  {
    id: 16,
    name: "Rubber Ducky Fleece Shirt",
    category: "Fleece Shirt",
    price: "33.00",
    originalPrice: "48.00",
    discount: "31%",
    reviews: "55",
    rating: "4.7",
    image: "/img/1016.jpeg",
    images: [
      "/img/1016.jpeg",
      "/img/1016a.jpeg",
      "/img/1016b.jpeg",
      "/img/1016c.jpeg",
    ],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Yellow"],
    material: "Polar Fleece",
    description: [
      "Bring sunshine to any day with this cheerful rubber ducky themed fleece shirt in bright yellow.",
      "The playful ducky print adds whimsy and charm, perfect for pets with fun-loving personalities.",
      "The polar fleece material ensures your pet stays warm while looking absolutely adorable.",
    ],
    Features: [
      "Playful rubber ducky print",
      "Bright cheerful yellow color",
      "Soft polar fleece material",
      "Button front styling",
      "Relaxed comfortable fit",
      "Anti-pill fleece technology",
      "Discounted sale price",
    ],
    soldOut: false,
  },
  {
    id: 17,
    name: "The Silver Linings Puffer Jacket",
    category: "Parka",
    price: "88.00",
    originalPrice: null,
    reviews: "28",
    rating: "4.8",
    image: "/img/1017.jpeg",
    images: [
      "/img/1017.jpeg",
      "/img/1017a.jpeg",
      "/img/1017b.jpeg",
      "/img/1017c.jpeg",
      "/img/1017d.jpeg",
    ],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Silver"],
    material: "Down Alternative Fill",
    description: [
      "Inspired by the saying 'every cloud has a silver lining,' this elegant puffer jacket features sophisticated silver-toned patterning.",
      "The premium down alternative fill provides excellent insulation while keeping the jacket lightweight and comfortable.",
      "A modern take on the classic dog puffer, this jacket combines practicality with refined style.",
    ],
    Features: [
      "Silver-toned cloud pattern design",
      "Lightweight down alternative fill",
      "Quilted construction",
      "Full zipper closure",
      "Hooded for warmth",
      "Wind resistant outer shell",
      "Water-resistant coating",
    ],
    soldOut: true,
  },
  {
    id: 18,
    name: "The Damien Puffer Jacket",
    category: "Parka",
    price: "88.00",
    originalPrice: null,
    reviews: "22",
    rating: "4.7",
    image: "/img/1018.jpeg",
    images: ["/img/1018.jpeg", "/img/1018a.jpeg", "/img/1018b.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Pink"],
    material: "Down Alternative Fill",
    description: [
      "A bold and beautiful puffer jacket in a striking pink palette, named after a design that exudes confidence and flair.",
      "This jacket proves that functional pet outerwear can also be fashionable and eye-catching.",
      "The premium construction ensures warmth and durability through multiple winter seasons.",
    ],
    Features: [
      "Vibrant pink colorway",
      "Premium down alternative insulation",
      "Fashion-forward quilted design",
      "Easy zippered closure",
      "Protective hood included",
      "Windproof outer material",
      "Soft interior lining",
    ],
    soldOut: true,
  },
  {
    id: 19,
    name: "The Betty Puffer Jacket",
    category: "Parka",
    price: "88.00",
    originalPrice: null,
    reviews: "25",
    rating: "4.8",
    image: "/img/1019.jpeg",
    images: ["/img/1019.jpeg", "/img/1019a.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Black"],
    material: "Down Alternative Fill",
    description: [
      "A timeless black puffer jacket named Betty, offering classic elegance and versatile styling for any pet.",
      "The sophisticated dark color hides dirt and wear, making it a practical choice for active pets who love outdoor adventures.",
      "Despite its dark color, this jacket doesn't compromise on warmth or quality construction.",
    ],
    Features: [
      "Classic black colorway",
      "Premium insulation fill",
      "Modern quilted styling",
      "Durable zipper closure",
      "Attached hood design",
      "Weather-resistant outer",
      "Easy maintenance care",
    ],
    soldOut: true,
  },
  {
    id: 20,
    name: "The Strawberry Sweater",
    category: "Sweater",
    price: "67.00",
    originalPrice: null,
    reviews: "112",
    rating: "4.9",
    image: "/img/1020.jpeg",
    images: ["/img/1020.jpeg", "/img/1020a.jpeg", "/img/1020b.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Pink/Red"],
    material: "Cotton Knit",
    description: [
      "Sweet as a strawberry! This adorable knit sweater features charming strawberry details that add a touch of whimsy to your pet's wardrobe.",
      "Crafted from soft cotton knit with just the right amount of stretch for comfort and ease of movement.",
      "The flattering silhouette and eye-catching design make this sweater perfect for photos, parties, or everyday style.",
    ],
    Features: [
      "Delightful strawberry design",
      "Soft cotton blend knit",
      "Ribbed trim details",
      "Stretchy comfortable fit",
      "Lightweight yet warm",
      "Crew neckline styling",
      "Machine washable care",
    ],
    soldOut: false,
  },
  {
    id: 21,
    name: "Silver Linings 2 Sweater",
    category: "Sweater",
    price: "33.00",
    originalPrice: "67.00",
    discount: "51%",
    reviews: "145",
    rating: "4.8",
    image: "/img/101.jpeg",
    images: ["/img/101.jpeg", "/img/101a.jpeg", "/img/101b.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Grey/Blue"],
    material: "Knit",
    description: [
      "The sequel to our popular Silver Linings sweater, featuring updated colorways and patterns that continue the theme of finding brightness in every situation.",
      "This cozy knit sweater combines grey and blue tones in a sophisticated cloud-inspired pattern.",
      "An incredible value at 50% off, this sweater offers premium quality and style at an unbeatable price.",
    ],
    Features: [
      "Updated cloud-inspired pattern",
      "Grey and blue color combination",
      "Soft textured knit fabric",
      "Relaxed comfortable fit",
      "Ribbed cuffs and hem",
      "Breathable cotton blend",
      "Major sale discount applied",
    ],
    soldOut: false,
  },
  {
    id: 22,
    name: "Dijon Shirt",
    category: "Shirt",
    price: "46.00",
    originalPrice: null,
    reviews: "39",
    rating: "4.6",
    image: "/img/102.jpeg",
    images: ["/img/102.jpeg", "/img/102a.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Yellow"],
    material: "Cotton Jersey",
    description: [
      "Inspired by the sophisticated condiment, this Dijon-colored shirt brings a touch of culinary refinement to pet fashion.",
      "The warm mustard yellow tone flatters a variety of fur colors and skin tones.",
      "Part of our expanding shirt collection, this piece demonstrates how everyday objects can inspire charming pet designs.",
    ],
    Features: [
      "Sophisticated mustard yellow color",
      "Classic stripe pattern design",
      "Lightweight cotton jersey",
      "Button front closure",
      "Relaxed fit design",
      "Versatile styling options",
      "Complete shirt collection available",
    ],
    soldOut: false,
  },
  {
    id: 23,
    name: "Earth and Fire Shirt",
    category: "Shirt",
    price: "46.00",
    originalPrice: null,
    reviews: "27",
    rating: "4.7",
    image: "/img/103.jpeg",
    images: ["/img/103.jpeg", "/img/103a.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Brown/Red"],
    material: "Cotton",
    description: [
      "Channel the elements with this earthy and warm shirt featuring a harmonious blend of brown and red tones.",
      "The color combination evokes images of autumn leaves, campfires, and the comforting warmth of nature.",
      "A versatile piece that works equally well for outdoor adventures or cozy indoor relaxation.",
    ],
    Features: [
      "Earth and fire color theme",
      "Warm brown and red stripes",
      "Natural cotton fabric",
      "Button-down styling",
      "Versatile everyday wear",
      "Comfortable relaxed fit",
      "Coordinated onesie available",
    ],
    soldOut: false,
  },
  {
    id: 24,
    name: "Earth and Sky Shirt",
    category: "Shirt",
    price: "46.00",
    originalPrice: null,
    reviews: "31",
    rating: "4.8",
    image: "/img/104.jpeg",
    images: ["/img/104.jpeg", "/img/104a.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Blue/Brown"],
    material: "Cotton",
    description: [
      "A dreamy combination of earth and sky colors, this shirt features soothing blue and warm brown tones.",
      "The palette represents the natural connection between ground and heavens, creating a calming aesthetic.",
      "Perfect for contemplative pets who appreciate the beauty of nature's color combinations.",
    ],
    Features: [
      "Sky blue and earth brown stripes",
      "Nature-inspired color palette",
      "Soft cotton construction",
      "Classic button-front design",
      "All-day comfortable wear",
      "Matches Earth and Sky Onesie",
      "Ideal for any season",
    ],
    soldOut: false,
  },
  {
    id: 25,
    name: "Ivy League Onesie",
    category: "Onesie",
    price: "48.00",
    originalPrice: null,
    reviews: "56",
    rating: "4.9",
    image: "/img/105.jpeg",
    images: ["/img/105.jpeg", "/img/105a.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Green/White"],
    material: "Cotton",
    description: [
      "For the sophisticated pet who dreams of campus life, this Ivy League-inspired onesie features classic collegiate stripes.",
      "The preppy green and white color scheme evokes traditional university aesthetics with timeless appeal.",
      "Snap button closure and full-body coverage make this onesie both practical and undeniably stylish.",
    ],
    Features: [
      "Classic collegiate stripe pattern",
      "Preppy green and white colors",
      "Full snap button closure",
      "Comfortable cotton fabric",
      "Extended size range available",
      "Matching shirt option",
      "Perfect for school spirit events",
    ],
    soldOut: false,
  },
  {
    id: 26,
    name: "Ivy League Shirt",
    category: "Shirt",
    price: "46.00",
    originalPrice: null,
    reviews: "48",
    rating: "4.8",
    image: "/img/106.jpeg",
    images: ["/img/106.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Green/White"],
    material: "Cotton",
    description: [
      "The shirt version of our popular Ivy League collection, offering the same refined collegiate style in a more relaxed fit.",
      "Ideal for warmer weather or pets who prefer less coverage while maintaining the sophisticated look.",
      "A wardrobe essential for the academically inclined pet who values classic style.",
    ],
    Features: [
      "Matching Ivy League stripe design",
      "Green and white preppy colors",
      "Lightweight cotton material",
      "Button-front closure",
      "Versatile styling choices",
      "Pairs with Ivy League collar",
      "Available in all sizes",
    ],
    soldOut: false,
  },
  {
    id: 27,
    name: "Earth and Fire Onesie",
    category: "Onesie",
    price: "48.00",
    originalPrice: null,
    reviews: "38",
    rating: "4.7",
    image: "/img/107.jpeg",
    images: ["/img/107.jpeg", "/img/107a.png"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Brown/Red"],
    material: "Cotton",
    description: [
      "The full-body onesie version of our Earth and Fire collection, providing complete coverage with the same warm color palette.",
      "Perfect for pets who need extra warmth, have skin conditions requiring coverage, or simply love the onesie style.",
      "The brown and red stripes create a bold statement that captures elemental power and energy.",
    ],
    Features: [
      "Earth fire color theme onesie",
      "Full body stripe pattern",
      "Snap button easy closure",
      "Warm cotton construction",
      "Extended size range",
      "Matches Earth Fire Shirt",
      "Ideal for cooler weather",
    ],
    soldOut: false,
  },
  {
    id: 28,
    name: "Dijon Onesie",
    category: "Onesie",
    price: "48.00",
    originalPrice: null,
    reviews: "42",
    rating: "4.8",
    image: "/img/108.jpeg",
    images: ["/img/108.jpeg", "/img/108a.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Yellow"],
    material: "Cotton Jersey",
    description: [
      "The complete onesie version of our popular Dijon Shirt, featuring the same sophisticated mustard-inspired design.",
      "Full body coverage makes this onesie perfect for layering, warmth, or medical needs requiring fabric coverage.",
      "The warm yellow tones brighten any look while keeping your pet comfortable throughout the day.",
    ],
    Features: [
      "Dijon mustard yellow color",
      "Classic stripe pattern onesie",
      "Snap button front closure",
      "Soft cotton jersey fabric",
      "Comprehensive size range",
      "Coordinated shirt available",
      "Versatile for all occasions",
    ],
    soldOut: false,
  },
  {
    id: 29,
    name: "Earth and Sky Onesie",
    category: "Onesie",
    price: "48.00",
    originalPrice: null,
    reviews: "35",
    rating: "4.9",
    image: "/img/109.jpeg",
    images: ["/img/109.jpeg", "/img/109a.jpeg"],
    size: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Blue/Brown"],
    material: "Cotton",
    description: [
      "Experience the tranquility of nature with this full-body onesie featuring the harmonious Earth and Sky color palette.",
      "The combination of grounding brown and calming blue creates a balanced aesthetic that appeals to design-conscious pet owners.",
      "Ideal for pets who embody the peaceful spirit of nature, this onesie provides comfort and style in equal measure.",
    ],
    Features: [
      "Earth and sky calming colors",
      "Full body stripe coverage",
      "Easy snap button closure",
      "Soft breathable cotton",
      "Extended XXS to XXL sizes",
      "Matches Earth Sky Shirt",
      "Perfect for nature lovers",
    ],
    soldOut: false,
  },
  {
    id: 30,
    name: "Snoopy Strollin Poop Bag Holder",
    category: "Poop Bag Holder",
    price: "25.00",
    originalPrice: null,
    reviews: "18",
    rating: "4.5",
    image: "/img/1010.jpeg",
    images: ["/img/1010.jpeg"],
    size: ["OS"],
    colors: ["Green"],
    material: "Polyester",
    description: [
      "A delightful PEANUTS collaboration featuring Snoopy in a strolling pose, perfect for responsible pet owners on the go.",
      "This compact holder attaches easily to any leash and keeps poop bags readily accessible during walks.",
      "The cheerful design makes responsible pet ownership a Liiskerlane more fun while showcasing your love for Snoopy.",
    ],
    Features: [
      "Official PEANUTS licensed product",
      "Snoopy strolling graphic design",
      "Attaches to any leash style",
      "Holds standard poop bags",
      "Easy-access opening",
      "Durable polyester material",
      "Available in multiple colors",
    ],
    soldOut: true,
  },
  {
    id: 31,
    name: "Snoopy Huggin Poop Bag Holder",
    category: "Poop Bag Holder",
    price: "25.00",
    originalPrice: null,
    reviews: "15",
    rating: "4.6",
    image: "/img/1011.jpeg",
    images: ["/img/1011.jpeg"],
    size: ["OS"],
    colors: ["Red"],
    material: "Polyester",
    description: [
      "Spread love while cleaning up with this Snoopy Huggin poop bag holder featuring the lovable beagle in an affectionate pose.",
      "A practical accessory that combines functionality with the charm of the PEANUTS gang.",
      "The bright red color makes this holder easy to locate, while the fun design brings joy to every walk.",
    ],
    Features: [
      "PEANUTS officially licensed",
      "Hugging Snoopy design",
      "Bright red color option",
      "Universal leash attachment",
      "Includes poop bag dispenser",
      "Weather-resistant material",
      "Part of Snoopy collection",
    ],
    soldOut: true,
  },
  {
    id: 32,
    name: "Snoopy Chillin Poop Bag Holder",
    category: "Poop Bag Holder",
    price: "25.00",
    originalPrice: null,
    reviews: "20",
    rating: "4.7",
    image: "/img/1012.jpeg",
    images: [
      "/img/1012.jpeg",
      "/img/1012a.jpeg",
      "/img/1012b.jpeg",
      "/img/1012c.jpeg",
    ],
    size: ["OS"],
    colors: ["Black"],
    material: "Polyester",
    description: [
      "Keep it cool with this Snoopy Chillin poop bag holder featuring everyone's favorite beagle in a relaxed pose.",
      "The sleek black design complements any leash or collar while maintaining the playful PEANUTS character.",
      "A must-have accessory for PEANUTS fans who want to maintain cleanliness during their adventures with their pet.",
    ],
    Features: [
      "Official PEANUTS merchandise",
      "Cool Snoopy design",
      "Classic black colorway",
      "Secure clip attachment",
      "Holds standard size bags",
      "Compact portable size",
      "Coordinates with collection",
    ],
    soldOut: true,
  },
  {
    id: 33,
    name: "Snoopy and Woodstock Raincoat - Navy",
    category: "Raincoat",
    price: "58.00",
    originalPrice: null,
    reviews: "52",
    rating: "4.8",
    image: "/img/1013.jpeg",
    images: [
      "/img/1013.jpeg",
      "/img/1013a.jpeg",
      "/img/1013b.jpeg",
      "/img/1013c.jpeg",
    ],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Navy"],
    material: "Waterproof Polyester",
    description: [
      "A charming PEANUTS collaboration raincoat featuring Snoopy and Woodstock adventures in navy blue.",
      "This fully waterproof raincoat keeps your pet dry while showcasing beloved characters from the PEANUTS comic strip.",
      "The adjustable fit and thoughtful design make rainy day walks something to look forward to.",
    ],
    Features: [
      "Official PEANUTS licensed product",
      "Snoopy and Woodstock print design",
      "100% waterproof construction",
      "Adjustable belly strap",
      "Hooded for full protection",
      "Reflective trim for safety",
      "Available in navy and yellow",
    ],
    soldOut: true,
  },
  {
    id: 34,
    name: "Snoopy and Woodstock Raincoat - Yellow/Blue",
    category: "Raincoat",
    price: "58.00",
    originalPrice: null,
    reviews: "48",
    rating: "4.9",
    image: "/img/1014.jpeg",
    images: [
      "/img/1014.jpeg",
      "/img/1014a.jpeg",
      "/img/1014b.jpeg",
      "/img/1014c.jpeg",
    ],
    size: ["XXS", "XS", "S", "M", "L", "XL"],
    colors: ["Yellow/Blue"],
    material: "Waterproof Polyester",
    description: [
      "A vibrant alternative to the navy version, this PEANUTS raincoat features Snoopy and Woodstock in cheerful yellow and blue tones.",
      "The bright color combination adds joy to gloomy weather while maintaining full waterproof protection.",
      "Perfect for PEANUTS enthusiasts who want to brighten up rainy day walks with beloved characters.",
    ],
    Features: [
      "PEANUTS officially licensed",
      "Yellow and blue color scheme",
      "Complete waterproof protection",
      "Snoopy and Woodstock graphics",
      "Adjustable comfortable fit",
      "Hooded weather protection",
      "Matching leash hole design",
    ],
    soldOut: true,
  },
  {
    id: 35,
    name: "Love Drives Me Crazy Canvas Tote",
    category: "Carrier",
    price: "112.00",
    originalPrice: "160.00",
    discount: "30%",
    reviews: "14",
    rating: "4.8",
    image: "/img/1015.jpeg",
    images: ["/img/1015.jpeg", "/img/1015a.jpeg", "/img/1015b.jpeg"],
    size: ["OS"],
    colors: ["Red/Blue"],
    material: "Canvas",
    description: [
      "A PEANUTS collaboration tote featuring Snoopy and Woodstock with the playful 'Love Drives Me Crazy' message.",
      "This versatile canvas tote works as both a stylish accessory and functional pet carrier for light travel.",
      "The artistic design adds personality to everyday errands while keeping your furry friend close by.",
    ],
    Features: [
      "Official PEANUTS collaboration",
      "Love themed graphic design",
      "Premium canvas material",
      "Spacious interior compartment",
      "Comfortable shoulder straps",
      "Interior pet pocket",
      "Significant sale discount",
    ],
    soldOut: false,
  },
  {
    id: 36,
    name: "The Liiskerlane Poop Bag Tote",
    category: "Poop Bag Holder",
    price: "25.00",
    originalPrice: null,
    reviews: "22",
    rating: "4.6",
    image: "/img/1016.jpeg",
    images: [
      "/img/1016.jpeg",
      "/img/1016a.jpeg",
      "/img/1016b.jpeg",
      "/img/1016c.jpeg",
    ],
    size: ["OS"],
    colors: ["Leopard"],
    material: "Polyester",
    description: [
      "The signature Liiskerlane poop bag tote featuring our iconic leopard print pattern.",
      "A practical and stylish solution for responsible pet owners who appreciate the Liiskerlane aesthetic.",
      "Compact yet spacious enough to hold multiple bags and small essentials for your walks.",
    ],
    Features: [
      "Signature leopard print design",
      "Compact practical size",
      "Leash clip attachment",
      "Holds standard bags",
      "Multiple pattern options",
      "Durable polyester material",
      "Easy to clean fabric",
    ],
    soldOut: false,
  },
];

export default productData;
